import { render, staticRenderFns } from "./ReportModuleWrapper.vue?vue&type=template&id=6b4b751b&scoped=true&"
import script from "./ReportModuleWrapper.vue?vue&type=script&lang=js&"
export * from "./ReportModuleWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ReportModuleWrapper.vue?vue&type=style&index=0&id=6b4b751b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b751b",
  null
  
)

export default component.exports